import { UkPostCode } from "../Validation/RegExPatterns";
import { Address } from "../../../Wrap/Models/Domains/Address/Address";
import * as React from "react";
import { CountryCode } from "../../../Wrap/Constants/Enums/Domain/CountryCode";
import { TextBoxEditor } from "../TextBoxEditor";
import { SelectEditorFactory } from "../Factories/SelectEditorFactory";
import { CountryCodeMap } from "../../../applications/Shared/Entities/Maps/CountryCodeMap";
import { FormComponent } from "../FormComponent";
import { AddressDetailModel } from "../../../Wrap/Models/Models/Customer/AddressDetailModel";
import { PhysicalAddressType } from "../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import {
    IProcessComponentProps,
    ProcessComponent,
} from "../../../applications/Shared/Process/Process/ProcessComponent";

export interface IAddressProps extends IProcessComponentProps {
    address?: AddressDetailModel;
    editApply?: boolean;
    index: number;
    required?: boolean;
    addressType: PhysicalAddressType;
    handleChange?: () => void;
    onCCMChange: (changes) => void;
    country: CountryCode;
}

export class AddressEditorFields extends ProcessComponent<IAddressProps, any> {
    constructor(props: IAddressProps) {
        super(props);
    }

    componentDidMount() {
        if (this.props.onRef) {this.props.onRef(this);}
        if (!this.props.address?.Address?.Country) {
            this.props.onCCMChange([
                { value: 61, path: `AddressDetails.${this.props.index}.Address.Country` },
                {
                    value: this.props.addressType,
                    path: `AddressDetails.${this.props.index}.PhysicalAddressType`,
                },
            ]);
        }
    }

    public render(): JSX.Element {
        const { onCCMChange, address, required, index, addressType } = this.props;
        const currentAddress = address || ({} as AddressDetailModel);
        const CountryCodeSelectEditor = SelectEditorFactory.create<CountryCode>();
        return (
            <>
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    label="Address line 1"
                    value={currentAddress.Address?.Address1?.substring(0, 35)}
                    maxLength={35}
                    required={required ? "You must enter address line 1." : null}
                    cssInput="input-large"
                    onChange={(v) => {
                        onCCMChange([
                            {
                                value: address?.PhysicalAddressType ? address?.PhysicalAddressType : addressType,
                                path: `AddressDetails.${index}.PhysicalAddressType`,
                            },
                            { value: v, path: `AddressDetails.${index}.Address.Address1` },
                        ]);
                    }}
                />

                <TextBoxEditor
                    cssWrapper="control-size-430"
                    label="Address line 2"
                    value={currentAddress.Address?.Address2?.substring(0, 35)}
                    maxLength={35}
                    required={required ? "You must enter address line 2." : null}
                    onChange={(v) => {
                        onCCMChange([
                            {
                                value: address?.PhysicalAddressType ? address?.PhysicalAddressType : addressType,
                                path: `AddressDetails.${index}.PhysicalAddressType`,
                            },
                            { value: v, path: `AddressDetails.${index}.Address.Address2` },
                        ]);
                    }}
                    cssInput="input-large"
                />

                <TextBoxEditor
                    cssWrapper="control-size-430"
                    label="Address line 3"
                    value={currentAddress.Address?.Address3}
                    maxLength={35}
                    onChange={(v) => {
                        onCCMChange([
                            {
                                value: address?.PhysicalAddressType ? address?.PhysicalAddressType : addressType,
                                path: `AddressDetails.${index}.PhysicalAddressType`,
                            },
                            { value: v, path: `AddressDetails.${index}.Address.Address3` },
                        ]);
                    }}
                    cssInput="input-large"
                />

                {/* <TextBoxEditor
                    cssWrapper="control-size-430"
                    label="City"
                    value={currentAddress.Address?.Address4}
                    required={required ? "You must enter the city." : ""}
                    cssInput="input-large"
                    onChange={(v) => {
                        onCCMChange([
                            {
                                value: address?.PhysicalAddressType ? address?.PhysicalAddressType : addressType,
                                path: `AddressDetails.${index}.PhysicalAddressType`,
                            },
                            { value: v, path: `AddressDetails.${index}.Address.Address4` },
                        ]);
                    }}
                /> */}
                <CountryCodeSelectEditor
                    cssWrapper="control-size-430"
                    label="Country"
                    selected={currentAddress.Address?.Country ? currentAddress.Address?.Country : this.props.country}
                    options={
                        addressType == PhysicalAddressType.Residential
                            ? [this.props.country]
                            : CountryCodeMap.getArray()
                    }
                    getText={(option) => CountryCodeMap.getString(option)}
                    onChange={(v) => {
                        onCCMChange([
                            {
                                value: address?.PhysicalAddressType ? address?.PhysicalAddressType : addressType,
                                path: `AddressDetails.${index}.PhysicalAddressType`,
                            },
                            { value: v, path: `AddressDetails.${index}.Address.Country` },
                        ]);
                    }}
                    placeholder={"Please select"}
                    required={required ? "You must select a country." : null}
                />
                <TextBoxEditor
                    cssWrapper="control-size-430"
                    label="Postcode"
                    value={currentAddress.Address?.PostCode?.toUpperCase()}
                    required={
                        currentAddress?.Address?.Country != CountryCode.GBR
                            ? null
                            : required
                            ? "You must enter a postcode."
                            : null
                    }
                    maxLength={20}
                    regex={
                        addressType == PhysicalAddressType.Residential ||
                        currentAddress.Address?.Country == CountryCode.GBR
                            ? this.getUKPostcodeValidator(currentAddress)
                            : null
                    }
                    onChange={(v) => {
                        onCCMChange([
                            {
                                value: address?.PhysicalAddressType ? address?.PhysicalAddressType : addressType,
                                path: `AddressDetails.${index}.PhysicalAddressType`,
                            },
                            { value: v?.toUpperCase(), path: `AddressDetails.${index}.Address.PostCode` },
                        ]);
                    }}
                />
            </>
        );
    }

    private getUKPostcodeValidator(address: AddressDetailModel) {
        if (address.Address?.Country === CountryCode.GBR)
            {return {
                value: UkPostCode,
                errorMessage: "You must enter a valid UK postcode.",
            };}
        return null;
    }
}
